export default __webpack_public_path__ + "static/media/zone-management-2.f2a568d2.svg";